export default __webpack_public_path__ + "static/media/button-detail.9858a0ab.svg";